<script>
	// Stores 
	import { 
		textSite,
	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Seguro Conteúdo';

	import Vitrine		from './../components/Vitrine.svelte';

	let vitrines = [
		{
			image: 'familia.png', 
			imageMobile: 'familiaM.png', 
			title: 'Seguro conteúdo'
		},
	];
</script>

<Vitrine vitrines={vitrines} vitrineHeight="369px"/>

<section class="conteudo-internas section-seguroconteudo">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">
		<p>Você sabia que o seguro predial contra incêndio, previsto lei como obrigatório, cobre apenas a estrutura física do prédio? Isso quer dizer que seus bens não estão cobertos por esse seguro.</p>
		<p>Foi pensando na sua segurança e tranquilidade que a SP Imobiliária e a Nossa Corretora Seguros estão ofertando um plano especial de Seguro Conteúdo (cobertura específica de incêndio) para seu patrimônio.</p>
		<div class="premios">
			<div class="itens">
				<div class="item">
					<h4>Residencial</h4>
					<div class="table">
						<div class="table-itens">
							<div class="table-item">Incêndio Conteúdo</div>
							<div class="table-item">R$ 100.000,00</div>
						</div>
						<div class="table-itens">
							<div class="table-item">Perda de aluguel</div>
							<div class="table-item">R$ 10.000,00</div>
						</div>
						<div class="table-itens table-itens--destaque">
							<div class="table-item">Prêmio mensal</div>
							<div class="table-item">R$ 11,90</div>
						</div>
					</div>
				</div>
				<div class="item">
					<h4>Comercial</h4>
					<div class="table">
						<div class="table-itens">
							<div class="table-item">Incêndio Conteúdo</div>
							<div class="table-item">R$ 100.000,00</div>
						</div>
						<div class="table-itens">
							<div class="table-item">Perda de aluguel</div>
							<div class="table-item">R$ 10.000,00</div>
						</div>
						<div class="table-itens table-itens--destaque">
							<div class="table-item">Prêmio mensal</div>
							<div class="table-item">R$ 14,90</div>
						</div>
					</div>
				</div>
			</div>
			<small>*Valor indenizável até <span class="hidden-md hidden-lg hidden-sm"><br></span> o limite da contratação.</small>
		</div>
		<p class="text-justify">Informamos que no boleto que você vai receber está incluso o valor da corbertura.</p>
		<p class="text-justify">Vale lembrar, que a adesão ao seguro é opcional, caso você não queira aderir, basta descontar o valor da taxa total do boleto de pagamento (DOC) do condomínio/aluguel, ou se preferir entre em contato diretamente com a SP Imobiliária para fazer esta exclusão.</p>
		<hr />
		<div class="box-itens-icon">
			<div class="item mt-0 pt-0">
				<div class="icon maxw-200">
					<i class="fas fa-shield-check"></i>
				</div>
				<div class="infos">
					<ul style="line-height: 30px;">
						<li><b class="color-primary">Objetivo:</b> Seguro mensal/opcional de incêndio para cobertura de conteúdo existente do imóvel/unidade.</li>
						<li><b class="color-primary">Apólice:</b> Apólice mensal emitida pela seguradora em nome da Administradora.</li>
						<li><b class="color-primary">Contratação/Adesão:</b> Sem burocracia, simples. Basta efetuar o pagamento do valor sugerido no boleto de cobrança.</li>
						<li><b class="color-primary">Não contratar:</b> Basta excluir o valor sugerido no boleto e solicitar exclusão da cobrança.</li>
						<li><b class="color-primary">Vigência:</b> Primeiro dia do mês seguinte ao pagamento até o último dia referido do mês.</li>
					</ul>
				</div>
			</div>
		</div>
		<hr />
		<p class="text-center">Ao pagar o seguro no boleto o cliente esté de acordo com as condições gerais do produto.<br /><span class="color-primary">Para informações sobre as condições gerais do seguro, <a class="color-accent" href="https://www.mapfre.com.br/para-seus-negocios/patrimoniais/imobiliario/" target="_blank"><b>clique aqui</b></a></span>.</p>
		<div class="text-center">
			<a href="https://www.mapfre.com.br/para-seus-negocios/patrimoniais/imobiliario/" target="_blank">
				<img class="img-responsive" src="/assets/images/logoNossaCorretoraSeguros.png" alt="Logo Seguradora" title="Logo Seguradora">
			</a>
			<p class="text--smaller mt-10">Nossa Corretora RS LTDA<br>Rua Gomes Jardim, 723<br> Santana - Porto Alegre/RS<br>(51) 99954-9839<br>CNPJ: 49.383.988/0001-04</p>
		</div>
	</div>
</section>